"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createIconComponent = _interopRequireDefault(require("./utils/createIconComponent"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var IconPrintSolid = (0, _createIconComponent["default"])({
  content: _react["default"].createElement("g", null, _react["default"].createElement("path", {
    d: "M61.08 34.46H8.92a2.44 2.44 0 0 0-2.44 2.44v18.34a6.37 6.37 0 0 0 6.38 6.38h44.28a6.37 6.37 0 0 0 6.38-6.38V36.9a2.44 2.44 0 0 0-2.44-2.44zm-50 9.37a2.51 2.51 0 0 1 0-3.54 2.51 2.51 0 1 1 0 3.54zm45.38 9.73a2 2 0 0 1-2 2h-39a2 2 0 0 1-2-2v-3.28a2 2 0 0 1 2-2h39a2 2 0 0 1 2 2zM55.44 21.29a4 4 0 0 0-1.16-2.82l-8.84-8.91a4 4 0 0 0-2.84-1.18H18.51a4 4 0 0 0-4 3.95v19.24h40.93z"
  })),
  height: undefined,
  width: undefined
});
IconPrintSolid.displayName = 'IconPrintSolid';
var _default = IconPrintSolid;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@tecuity/sos-icons/react/print-solid.js
// module id = 580
// module chunks = 0